import { useEffect, useRef } from 'react';
import { compareIds } from 'util/support';
import type { TabsProps } from 'ui/atoms/Tabs';
import { OnboardingApplicationLogTab } from '../types';
import { useApplicationTableResourceContext } from '../../../ApplicationTableResourceProvider';
import { useOnboardingApplicationLogsRequest } from '../hooks';

export const useOnboardingStepsLogs = ({ value }: Pick<TabsProps, 'value'>) => {
    const {
        loading,
        toRows,
        fetchOnboardingLogsIfNotExists,
        fetchOnboardingLogs
    } = useOnboardingApplicationLogsRequest();

    const repository = {
        fetchOnboardingLogsIfNotExists
    };

    const repositoryRef = useRef(repository);
    repositoryRef.current = repository;

    const { context } = useApplicationTableResourceContext();

    const applicationId = context?.row.pki;

    useEffect(() => {
        repositoryRef.current.fetchOnboardingLogsIfNotExists({
            applicationId
        }, () => compareIds(`${value}`, OnboardingApplicationLogTab.Step));
    }, [applicationId, value]);

    return {
        loading,
        rows: toRows(),
        fetchOnboardingLogs
    };
};

export default useOnboardingStepsLogs;
